'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardAccountStats(account, name, total) {
  this.KS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.DL = null;
  this.DM = 0;
  this.KS = account;
  this.DL = name;
  this.DM = total;
}
export { $c_Lpresto_types$DashboardAccountStats as $c_Lpresto_types$DashboardAccountStats };
$p = $c_Lpresto_types$DashboardAccountStats.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardAccountStats;
/** @constructor */
function $h_Lpresto_types$DashboardAccountStats() {
}
export { $h_Lpresto_types$DashboardAccountStats as $h_Lpresto_types$DashboardAccountStats };
$h_Lpresto_types$DashboardAccountStats.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardAccountStats"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.KS;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.DL));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.DM);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 3);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$DashboardAccountStats)) {
    if ((this.DM === x$0.DM)) {
      var this$1 = this.KS;
      var b = x$0.KS;
      var $x_1 = ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.DL === x$0.DL);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "DashboardAccountStats";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.KS;
      break;
    }
    case 1: {
      return this.DL;
      break;
    }
    case 2: {
      return this.DM;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$DashboardAccountStats(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jE)));
}
export { $isArrayOf_Lpresto_types$DashboardAccountStats as $isArrayOf_Lpresto_types$DashboardAccountStats };
var $d_Lpresto_types$DashboardAccountStats = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardAccountStats, "presto.types$DashboardAccountStats", ({
  jE: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardAccountStats as $d_Lpresto_types$DashboardAccountStats };
//# sourceMappingURL=presto.types$-Dashboard-Account-Stats.js.map
